import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Lender } from '../../models/lender.model';
import { LenderList } from '../../models/lender-list.model';
import { ConfigService } from 'src/app/core/services/config-service';

@Injectable()
export class LenderService {
  constructor(private http: HttpClient) {}

  configService = inject(ConfigService);

  getLenders(): Observable<LenderList> {
    const listUrl = this.configService.readConfig().baseUrlInfrastructure + '/Lenders';

    const observable: Observable<LenderList> =
      this.http.get<LenderList>(listUrl);
    return observable;
  }

  createLender(lender: Lender): Observable<Lender> {
    const createUrl = this.configService.readConfig().baseUrlInfrastructure + '/Lenders';
    return this.http.post<Lender>(createUrl, lender);
  }

  deleteLender(lenderId: number): Observable<any> {
    const deleteUrl = this.configService.readConfig().baseUrlInfrastructure + '/Lenders/' + lenderId;
    return this.http.delete(deleteUrl);
  }

  updateLender(lender: Lender): Observable<Lender> {
    const updateUrl = this.configService.readConfig().baseUrlInfrastructure + '/Lenders/' + lender.id;
    return this.http.put<Lender>(updateUrl, lender);
  }
}
